import React, { useState, useEffect } from "react";

const PRESETS = [0, 5, 10, 15];

const CostInput = ({ value, onChange, onCommit }) => {
  const [showInput, setShowInput] = useState(!PRESETS.includes(Number(value)));
  const [inputValue, setInputValue] = useState(
    value != null && value !== "" ? String(value) : ""
  );

  useEffect(() => {
    if (!PRESETS.includes(Number(value)) && !showInput) {
      setShowInput(true);
    }
  }, [value, showInput]);

  // Sync local display value when preset is selected (value changes externally)
  useEffect(() => {
    if (!showInput) {
      setInputValue(value != null && value !== "" ? String(value) : "");
    }
  }, [showInput, value]);

  const handlePresetClick = (amount) => {
    onChange({ target: { value: amount } });
    setShowInput(false);
    onCommit?.(amount);
  };

  const onOtherClick = () => {
    setShowInput(!showInput);
  };

  const handleInputChange = (e) => {
    const raw = e.target.value;
    setInputValue(raw);
    onChange({ target: { value: raw } });
  };

  return (
    <div>
      <label
        htmlFor="cost"
        className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1"
      >
        Current Price
      </label>
      <div className="flex flex-wrap gap-2 mb-2">
        {!showInput &&
          PRESETS.map((amount) => (
            <button
              key={amount}
              type="button"
              onClick={() => handlePresetClick(amount)}
              className={`px-4 py-2 text-sm rounded-md border transition-colors ${
                !showInput && Number(value) === amount
                  ? "bg-primary text-white border-primary"
                  : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700"
              }`}
            >
              {amount === 0 ? "Free" : `$${amount}`}
            </button>
          ))}
        <button
          type="button"
          onClick={onOtherClick}
          className={`px-4 py-2 text-sm rounded-md border transition-colors ${
            showInput
              ? "bg-primary text-white border-primary"
              : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700"
          }`}
        >
          Other
        </button>
        {showInput && (
          <div className="relative rounded-md shadow-sm max-w-28">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm">$</span>
            </div>
            <input
              type="text"
              inputMode="decimal"
              name="cost"
              id="cost"
              className="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 dark:text-gray-100 dark:bg-gray-800 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="0.00"
              value={inputValue}
              onChange={handleInputChange}
              onBlur={() => onCommit?.(inputValue)}
            />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm">USD</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CostInput;
